import type { QuoteDocument } from '@/modules/quotes/types'
import { QUOTE_STATUS_LABELS } from '@/modules/quotes/types'

import type { ClientPdfDocument } from './client-pdf-document'
import { companyFromEmpresa } from './branding-from-empresa'

const dateFormatter = new Intl.DateTimeFormat('pt-BR', {
  day: '2-digit',
  month: 'long',
  year: 'numeric',
})

export function quoteToClientPdf(quote: QuoteDocument): ClientPdfDocument {
  return {
    number: quote.code,
    title: quote.title?.trim() || 'Proposta comercial',
    issuedAtLabel: dateFormatter.format(new Date(quote.quoteDate)),
    statusLabel: QUOTE_STATUS_LABELS[quote.status],
    company: companyFromEmpresa(),
    client: {
      name: quote.customerName?.trim() || 'Cliente não informado',
    },
    items: quote.items.map((item) => ({
      description: item.description,
      quantity: item.quantity,
      unitPrice: item.salePrice,
      lineTotal: item.subtotal,
    })),
    summary: {
      subtotal: quote.totals.subtotal,
      discountTotal: quote.totals.discount,
      shipping: quote.totals.freight,
      total: quote.totals.total,
    },
    terms: {
      validity: `${quote.validUntilDays} dias`,
    },
    notes: quote.notes.trim() || undefined,
  }
}
